// WP-3.7 (M19 TL-1/2, S-29 `/timeline`): the global scope of TL-1's "three scopes" — party
// and project scopes render the same `TimelineFeed` embedded on S-20/S-24.
import { TimelineFeed } from '../components/TimelineFeed';

export function TimelinePage(): React.JSX.Element {
  return (
    <div>
      <h1 className="mb-4 text-xl font-semibold text-ink">Timeline</h1>
      <TimelineFeed />
    </div>
  );
}
